import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";

export default function ManageCompanyProfile() {
  const path = "Assets/scss/hireexpert.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  return (
    <div className="hire-details manage-profile">
      <h2>Manage profile</h2>
      <div className="expertdetail-first">
        <div className="expertdetail-row">
          <div className="expert-left">
            <div className="expert-leftprofile">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/expert-1.svg`}
                alt=""
              />
              <button className="btn camera-icon">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/camera.svg`}
                  alt=""
                />
              </button>
            </div>
            <div>
              <h2 className="manage-head">Imcrinox technologies Pvt. Ltd.</h2>
              <h6>
                <span>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/map-icon.svg`}
                    alt=""
                  />
                  India
                </span>
                CR No.: 8273998912
              </h6>
            </div>
          </div>
          <div className="expert-right">
            <button className="btn message-btn">Public Preview</button>
            <button className="btn active message-btn">Profile settings</button>
          </div>
        </div>
      </div>
      <div className="expertdetail-second ">
        <div className="row">
          <div className="col-lg-3 col-md-4 expert-second-left d-flex flex-column" style={{rowGap:'10px'}}>
            {/* <p className="about-me">About Expert</p> */}
            <div className="about-expert">
              <h6>
                language
                <a>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </h6>
              <p>English - Fluent</p>
              <p>Arabic - Fluent</p>
            </div>
            <div className="about-expert">
              <h6>
                Academic info
                <a>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </h6>
              <p>MBA - University of Hunnah</p>
              <p>2020-2023</p>
            </div>
            <div className="about-expert">
              <h6>
                Employment
                <a>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </h6>
              <p>UX designer</p>
              <p>Google - 2020-2023</p>
            </div>
            <div className="about-expert">
              <h6>
                Charges
                <a>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </h6>
              <p>$15/hour</p>
              <p>$1200/month</p>
            </div>
            <div className="about-expert">
              <h6>
                Working Days
                <a>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </h6>
              <p>Mon, Tue, Wed, Thur, Fri</p>
            </div>
            <div className="about-expert">
              <h6>
                Working Hour
                <a>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </h6>
              <p>9:30am - 12:30pm</p>
              <p>3 pm - 8pm</p>
            </div>
          </div>
          <div className="col-lg-9 col-md-8 expert-second-right">
            <h4 className="d-flex justify-content-between align-items-center">
              UI Designer
              <a>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                  alt=""
                />
              </a>
            </h4>
            <p>
              Lorem ipsum dolor sit amet consectetur. Et neque id nunc faucibus
              neque auctor massa tempor turpis. Id ac massa tellus sollicitudin
              vitae. Congue quam sed egestas cras sed non adipiscing. Amet mi
              sed viverra pellentesque fusce vestibulum. Ullamcorper orci nisi
              dolor congue mauris fames. Eu integer lorem ullamcorper euismod
              lobortis vitae felis nunc. Accumsan vulputate sed odio nunc
              vivamus tempus vitae. Imperdiet etiam mi amet nisi nunc
              consectetur malesuada sit. Neque varius pellentesque elit interdum
              iaculis netus venenatis et. Vulputate leo purus amet est lacus
              tortor. Mauris amet libero dolor eget pharetra purus. Diam at
              dolor egestas ac nulla nisi aenean. Tellus ac nam nec malesuada
              morbi. Sed adipiscing volutpat id ut at lobortis.
            </p>
            <div className="expert-sub-sec">
              <div className="expert-heading">
                <h6>Competencies </h6>
                <a>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </div>
              <div className="skills">
                <p>Photoshop</p>
                <p>Figma</p>
                <p>Drawing</p>
                <p>Branding</p>
                <p>Website</p>
              </div>
            </div>
            <div className="expert-sub-sec">
              <div className="expert-heading">
                <h6>Work samples</h6>
                <button className="btn">View all</button>
              </div>
              <div className="row exp-row">
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>App design for trasp…</h5>
                </div>
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>App design for trasp…</h5>
                </div>
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>App design for trasp…</h5>
                </div>
              </div>
            </div>
            <div className="expert-sub-sec">
              <div className="expert-heading">
                <h6>One time service (OTS)</h6>
                <button className="btn">View all</button>
              </div>
              <div className="row exp-row">
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>Branding and print designs</h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy…
                  </p>
                  <h5>$800</h5>
                </div>
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>Branding and print designs</h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy…
                  </p>
                  <h5>$800</h5>
                </div>
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>Branding and print designs</h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy…
                  </p>
                  <h5>$800</h5>
                </div>
              </div>
            </div>
            <div className="rating-sec">
              <h2>Rating and Reviews </h2>
              <div className="overall-rating">
                <div className="earn-head">
                  <h2>Average rating</h2>
                  <div className="star">
                    <p>
                      <i className="fa-solid fa-star"></i>
                      <span>4.5</span> (12 reviews)
                    </p>
                  </div>
                </div>
                <div className="review-right">
                  <div className="review-star">
                    <p>Satisfaction rating </p>
                    <div className="star-sec">
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star disabled"></i>
                    </div>
                  </div>
                  <div className="review-star">
                    <p>Execution rating </p>
                    <div className="star-sec">
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star disabled"></i>
                    </div>
                  </div>
                  <div className="review-star">
                    <p>Your experience with expert </p>
                    <div className="star-sec">
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star disabled"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rating-detail">
                <p>
                  Turpis suspendisse elementum tincidunt ac viverra in
                  scelerisque. Ipsum porta in vulputate fringilla urna.
                  Fermentum etiam sed id iaculis leo. Ultricies tempus sit proin
                  ultrices habitant odio metus
                </p>
                <h5>Kianna Stanton</h5>
              </div>
              <div className="rating-detail">
                <p>
                  Turpis suspendisse elementum tincidunt ac viverra in
                  scelerisque. Ipsum porta in vulputate fringilla urna.
                  Fermentum etiam sed id iaculis leo. Ultricies tempus sit proin
                  ultrices habitant odio metus
                </p>
                <h5>Kianna Stanton</h5>
              </div>
              <div className="rating-detail">
                <p>
                  Turpis suspendisse elementum tincidunt ac viverra in
                  scelerisque. Ipsum porta in vulputate fringilla urna.
                  Fermentum etiam sed id iaculis leo. Ultricies tempus sit proin
                  ultrices habitant odio metus
                </p>
                <h5>Kianna Stanton</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
